import { BUTTON_STYLES, WRAPPER_STYLES_ATTRIBUTES, BUTTON_STYLING_CLASS_MAP } from "./constants";
import { CallToAction } from "./CallToActionButton";

const getWrapperStyles = buttonStyling =>
	buttonStyling
		.flatMap(styleKey => {
			if (WRAPPER_STYLES_ATTRIBUTES.includes(styleKey)) {
				return `${BUTTON_STYLING_CLASS_MAP[styleKey] || ""}`;
			}
			return [];
		})
		.join(" ")
		.trim() || "";

export const CTAWrapper = ({ cta, parsedClasses = "", fullWidth = false, parsedFunctions = {}, inline = false }) => {
	const displayWrapperFullWidth = cta?.buttonStyling?.includes(BUTTON_STYLES.FULL_WIDTH) || fullWidth;
	const wrapperStyles = getWrapperStyles(cta?.buttonStyling ?? []);

	return (
		inline ? <span className={`${wrapperStyles} ${parsedClasses} ${cta?.mobileOnly ? "lg:hidden" : ""} ${cta?.desktopOnly ? "hidden lg:inline" : ""}`}><CallToAction title={cta?.buttonText || cta?.title} {...cta} parsedFunctions={parsedFunctions} /></span>
		:
			<div
				className={`w-full  ${
					displayWrapperFullWidth ? "md:w-full [&_a]:w-full" : "md:w-fit"
				} flex flex-col md:flex-row gap-0 md:gap-4 items-center  ${wrapperStyles} ${parsedClasses} ${cta?.mobileOnly ? "lg:hidden" : ""} ${cta?.desktopOnly ? "hidden lg:flex" : ""}`}
			>
				{cta?.separator && <p className={`m-0`}>{cta.separator}</p>}
				{cta && <CallToAction title={cta?.buttonText || cta?.title} {...cta} parsedFunctions={parsedFunctions} isStatic={cta?.isStatic ?? false} />}
			</div>
		
	);
};
